module.exports = __webpack_public_path__ + "static/media/NotificationAnnouncements.c472fe2b.svg";